export default {
  "about.heroAlt": "Baja California Sur",
  "about.missionImageAlt": "Turistas disfrutando de Baja",
  "about.title": "Sobre nosotros",
  "about.subtitle": "Conectamos viajeros con experiencias auténticas en Baja California Sur",
  "about.missionTitle": "Nuestra misión",
  "about.missionP1": "BajApp Xperiences nació del amor por nuestra tierra y el deseo de compartir sus maravillas con el mundo. Creemos que las mejores experiencias de viaje son aquellas que te conectan con la cultura local, la naturaleza y la gente que hace único cada destino.",
  "about.missionP2": "Trabajamos de la mano con proveedores locales — pescadores, artesanos, chefs, guías — para ofrecer experiencias auténticas que van más allá de los circuitos turísticos típicos. Cada tour, cada comida, cada traslado es una oportunidad para descubrir la Baja real.",
  "about.statTours": "Experiencias disponibles",
  "about.statProviders": "Proveedores locales",
  "about.statTravelers": "Viajeros felices",
  "about.statDestinations": "Destinos",
  "about.valuesTitle": "Nuestros valores",
  "about.value1Title": "Pasión por Baja",
  "about.value1Desc": "Cada experiencia que ofrecemos es elegida con amor por esta tierra y su gente.",
  "about.value2Title": "Confianza y seguridad",
  "about.value2Desc": "Verificamos todos los proveedores y garantizamos pagos seguros con Mercado Pago.",
  "about.value3Title": "Comunidad",
  "about.value3Desc": "Apoyamos las economías locales trabajando directamente con familias y pequeños negocios.",
  "about.value4Title": "Sostenibilidad",
  "about.value4Desc": "Promovemos un turismo responsable que respeta el medio ambiente y la vida marina.",
  "about.teamTitle": "Conoce al equipo",
  "about.ctaTitle": "¿Quieres saber más?",
  "about.ctaDesc": "Contáctanos y con gusto te contamos más sobre BajApp Xperiences.",
  "about.ctaButton": "Contactarnos",

  "how.title": "Cómo funciona",
  "how.subtitle": "Reservar tu próxima aventura en Baja California Sur es más fácil de lo que piensas",
  "how.step1Title": "Busca y compara",
  "how.step1Desc": "Explora cientos de experiencias únicas en La Paz, Los Cabos y Cabo San Lucas. Filtra por categoría, precio, fecha y más.",
  "how.step1d1": "Navega tours, transporte, hospedaje y experiencias gastronómicas",
  "how.step1d2": "Lee reseñas reales de otros viajeros",
  "how.step1d3": "Compara precios y qué incluye cada experiencia",
  "how.step2Title": "Reserva en minutos",
  "how.step2Desc": "Elige tu fecha, número de viajeros y completa tu reserva en pocos clics. Sin formularios complicados.",
  "how.step2d1": "Selecciona la fecha y hora perfectas para tu grupo",
  "how.step2d2": "Ingresa tus datos de contacto de forma segura",
  "how.step2d3": "Paga de forma segura con Mercado Pago (tarjetas, OXXO, SPEI)",
  "how.step3Title": "Disfruta la experiencia",
  "how.step3Desc": "Recibe confirmación instantánea y todos los detalles por correo. Solo llega y disfruta.",
  "how.step3d1": "Obtén confirmación instantánea e instrucciones detalladas",
  "how.step3d2": "Recibe recordatorios antes de tu experiencia",
  "how.step3d3": "Disfruta tu aventura y comparte tu reseña después",
  "how.trust1Title": "Pagos seguros",
  "how.trust1Desc": "Todas las transacciones se procesan a través de Mercado Pago con encriptación bancaria.",
  "how.trust2Title": "Cancelación gratuita",
  "how.trust2Desc": "Cancela hasta 24 horas antes de tu experiencia para reembolso completo en la mayoría de reservas.",
  "how.trust3Title": "Soporte 24/7",
  "how.trust3Desc": "Nuestro equipo está disponible por WhatsApp y correo para ayudarte con lo que necesites.",
  "how.faqTitle": "Preguntas frecuentes",
  "how.faq1Q": "¿Cómo sé que mi reserva está confirmada?",
  "how.faq1A": "Recibirás un correo de confirmación instantánea con todos los detalles de tu reserva, incluyendo fecha, hora, punto de encuentro y contacto del proveedor.",
  "how.faq2Q": "¿Puedo modificar mi reserva después de reservar?",
  "how.faq2A": "Sí, puedes modificar la fecha o número de viajeros hasta 48 horas antes de la experiencia, sujeto a disponibilidad.",
  "how.faq3Q": "¿Qué métodos de pago aceptan?",
  "how.faq3A": "Aceptamos tarjetas de crédito y débito, pagos en OXXO, transferencias SPEI y saldo de Mercado Pago.",
  "how.faq4Q": "¿Necesito imprimir mi reserva?",
  "how.faq4A": "No, solo muestra la confirmación digital en tu teléfono. El proveedor también tendrá tus datos.",
  "how.ctaButton": "Explorar experiencias",

  "provider.heroAlt": "Proveedor",
  "provider.testimonialAlt": "Proveedor",
  "provider.title": "¿Eres proveedor de servicios turísticos?",
  "provider.subtitle": "Únete a la plataforma de reservas líder en Baja California Sur y llega a miles de viajeros que buscan experiencias auténticas",
  "provider.ctaButton": "Registrarme como proveedor",
  "provider.statTravelers": "Viajeros al año",
  "provider.statTours": "Experiencias activas",
  "provider.statRating": "Valoración promedio",
  "provider.statCountries": "Países de origen",
  "provider.benefitsTitle": "¿Por qué unirte a BajApp Xperiences?",
  "provider.b1Title": "Llega a más viajeros",
  "provider.b1Desc": "Accede a miles de turistas nacionales e internacionales que buscan activamente experiencias en Baja.",
  "provider.b2Title": "Gestión sencilla de reservas",
  "provider.b2Desc": "Administra tu calendario, reservas y disponibilidad desde un panel simple e intuitivo.",
  "provider.b3Title": "Pagos seguros",
  "provider.b3Desc": "Recibe tus pagos directamente en tu cuenta bancaria. Sin perseguir clientes para cobrar.",
  "provider.b4Title": "Analíticas e insights",
  "provider.b4Desc": "Entiende tus ventas, fechas más populares, demografía de clientes y tendencias de crecimiento.",
  "provider.b5Title": "Soporte dedicado",
  "provider.b5Desc": "Nuestro equipo está aquí para ayudarte a tener éxito — desde la incorporación hasta optimizar tus listados.",
  "provider.b6Title": "Reseñas verificadas",
  "provider.b6Desc": "Genera confianza con reseñas auténticas de viajeros reales que experimentaron tu servicio.",
  "provider.stepsTitle": "Cómo empezar",
  "provider.s1Title": "Crea tu cuenta",
  "provider.s1Desc": "Regístrate como proveedor y completa tu perfil de negocio.",
  "provider.s2Title": "Publica tus experiencias",
  "provider.s2Desc": "Agrega fotos, descripciones, precios y disponibilidad para cada servicio.",
  "provider.s3Title": "Sé verificado",
  "provider.s3Desc": "Nuestro equipo revisa tu perfil para asegurar calidad y autenticidad.",
  "provider.s4Title": "Empieza a recibir reservas",
  "provider.s4Desc": "Los viajeros reservan directamente y recibes notificaciones al instante.",
  "provider.testimonial": "Desde que me uní a BajApp Xperiences, mis reservas de pesca deportiva se triplicaron. La plataforma me trae clientes de la Ciudad de México, Estados Unidos e incluso Europa. El sistema de pagos es confiable y el equipo de soporte es increíble.",
  "provider.testimonialName": "Javier Morales",
  "provider.testimonialRole": "Capitán, Baja Sport Fishing",
  "provider.bottomCtaTitle": "¿Listo para hacer crecer tu negocio?",
  "provider.bottomCtaDesc": "Únete a cientos de proveedores locales que ya usan BajApp Xperiences para llegar a más viajeros.",
};